var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.svgIconComponent,{tag:"component",class:{ 'rtl-flip-icon': _vm.rtlFlip },style:({ fill: _vm.computedColor })})
}
var staticRenderFns = []

export { render, staticRenderFns }